import { QueryClient } from '@tanstack/react-query';
import { Configuration, CoreClient } from '@givz/core-client';
import { config } from '@config';
import packageJson from '../../package.json';

export const queryClient = new QueryClient();
export const coreClient = (configuration?: Configuration) =>
  CoreClient(
    config.api.baseUrl,
    `web-app@${packageJson.version};`,
    configuration,
  );
